export enum UserSubscriptionType {
  UNSPECIFIED = 'USER_SUBSCRIPTION_TYPE_UNSPECIFIED',
  FREE = 'USER_SUBSCRIPTION_TYPE_FREE',
  GOLD = 'USER_SUBSCRIPTION_TYPE_GOLD',
}
